import { useRef, useCallback } from "react";
import { motion } from "framer-motion";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Mail, FileText } from "lucide-react";
import { RichTextEditor } from "@/components/RichTextEditor";

export function EmailEditor({ subject, body, onSubjectChange, onBodyChange, activeField, onFieldFocus, editorRef }) {
  const subjectRef = useRef(null);

  const handleSubjectFocus = useCallback(() => {
    onFieldFocus("subject");
  }, [onFieldFocus]);

  const handleBodyFocus = useCallback(() => {
    onFieldFocus("body");
  }, [onFieldFocus]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.2 }}
      className="space-y-5"
      data-testid="email-editor-section"
    >
      <div className="flex items-center gap-2 mb-1">
        <Mail className="w-4 h-4 text-primary" />
        <h3 className="text-sm font-bold tracking-wide uppercase text-zinc-500">
          Template d'email
        </h3>
      </div>

      <div className="space-y-2">
        <Label htmlFor="email-subject" className="text-sm font-medium text-zinc-700 flex items-center gap-2">
          <FileText className="w-3.5 h-3.5" />
          Objet
        </Label>
        <Input
          ref={subjectRef}
          id="email-subject"
          value={subject}
          onChange={(e) => onSubjectChange(e.target.value)}
          onFocus={handleSubjectFocus}
          placeholder="Ex: Bonjour {prenom}, votre offre spéciale..."
          className={`font-mono text-sm transition-all duration-200 ${activeField === "subject" ? "ring-2 ring-primary/30 border-primary" : ""}`}
          data-testid="email-subject-input"
        />
      </div>

      <div className="space-y-2">
        <Label className="text-sm font-medium text-zinc-700 flex items-center gap-2">
          <Mail className="w-3.5 h-3.5" />
          Corps de l'email
        </Label>
        <RichTextEditor
          value={body}
          onChange={onBodyChange}
          onFocus={handleBodyFocus}
          isActive={activeField === "body"}
          editorRef={editorRef}
        />
      </div>
    </motion.div>
  );
}
